import { Fragment } from 'react';

/**
 * Renders an assistant reply with `**bold**` shown as real bold.
 *
 * Deliberately tiny: ONLY `**text**` is understood. Everything else
 * (line breaks, numbered lines) stays as the model wrote it, and the output
 * is plain React elements - never injected HTML - so a reply cannot put
 * markup into the page.
 */
export function ChatMessageText({ text }: { text: string }) {
  // split() with a capturing group keeps the bold pieces at odd indexes.
  const parts = text.split(/\*\*(.+?)\*\*/gs);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="font-semibold">{part}</strong>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}

/** The reply as plain text - the ** markers removed - for copying. */
export function plainChatText(text: string): string {
  return text.replace(/\*\*(.+?)\*\*/gs, '$1');
}
